export default "__VITE_ASSET__7fc2d7d3__"